import { constantRouters, asyncRouters } from '@/backend/router/index';
import menuList from '@/common/menuDict';
import router from '@/backend/router/index';

const filterTree = function (tree, val) {
  let treeCopy = tree;
  let defaultFun = (treeItem, json) => {
    return treeItem.id && json.indexOf(treeItem.id) >= 0;
  };
  if (typeof val == 'function') {
    defaultFun = val;
  }
  let result = treeCopy.filter((item) => {
    if (defaultFun(item, val)) {
      if (item.children && item.children.length) {
        item.children = filterTree(item.children, val);
      }
      return true;
    }
    return false;
  });
  return result;
};

const permission = {
  state: {
    routerList: constantRouters,
    addRouters: [],
    asyncRouters: asyncRouters,
  },
  mutations: {
    ADD_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routerList = constantRouters.concat(routers);
    },
  },
  actions: {
    GenerateRouters({ commit }, data) {
      return new Promise((res) => {
        const list = data;
        const [...routers] = asyncRouters; //深拷贝异步加载路由,否则异步路由列表会被修改
        let accessRouters = filterTree(routers, (item) => {
          if (item.meta && item.meta.isValid && menuList[item.name]) {
            return list.find((permission) => {
              return permission.englishName === menuList[item.name].englishName;
            });
          }
          return true;
        });
        router.addRoutes(accessRouters);
        commit('ADD_ROUTERS', accessRouters);
        res(accessRouters);
      });
    },
  },
};
export default permission;
